import { api } from '../lib/api.ts';
import { useStore } from '../lib/store.ts';

/** Fetch the user's plan and usage from /auth/me into the store. Best effort. */
export async function refreshPlan(): Promise<void> {
  try {
    const user = await api.me();
    useStore.getState().setUser(user);
  } catch {
    // Offline or signed out: keep what we have.
  }
}

/** Whether Strava is on for this user (owner-only; hidden for everyone else). */
export function useStravaEnabled(): boolean {
  return useStore((s) => s.user?.features?.strava === true);
}

/** Whether Garmin Connect is on for this user (``features.garmin``). */
export function useGarminEnabled(): boolean {
  return useStore((s) => s.user?.features?.garmin === true);
}

/** Whether intervals.icu is on for this user (``features.intervals``). */
export function useIntervalsEnabled(): boolean {
  return useStore((s) => s.user?.features?.intervals === true);
}

/** Whether other activities (runs, swims, gym) are on (``features.activities``). */
export function useActivitiesEnabled(): boolean {
  return useStore((s) => s.user?.features?.activities === true);
}

/** The signed-in user's plan; ``isPro`` is false until the plan is known. */
export function usePlan() {
  const user = useStore((s) => s.user);
  return {
    isPro: user?.plan === 'pro',
    isFree: user?.plan === 'free',
    freeChatLeft: user?.free_chat_left ?? null,
    freeChatMonthly: user?.free_chat_monthly ?? null,
    proUntil: user?.pro_until ?? null,
    trial: user?.trial ?? false,
  };
}
